// extracted by mini-css-extract-plugin
module.exports = {"page":"lQ","account":"mQ","pdp":"nQ","cart":"oQ","brand":"pQ","cartModal":"qQ","checkout":"rQ"};